import { render, staticRenderFns } from "./BasicFacility.vue?vue&type=template&id=5e076da0&scoped=true&"
import script from "./BasicFacility.vue?vue&type=script&lang=js&"
export * from "./BasicFacility.vue?vue&type=script&lang=js&"
import style0 from "./BasicFacility.vue?vue&type=style&index=0&id=5e076da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e076da0",
  null
  
)

component.options.__file = "BasicFacility.vue"
export default component.exports